module.exports = __webpack_public_path__ + "src/assets/img/cmd-disarm.1f0edb65.svg";